export const listTef = [
  { textCredential: 'Credibanco Smartpos', valueCredential: '1' },
  { textCredential: 'Credibanco Smartpos Sin ID', valueCredential: '3' },
  { textCredential: 'Credibanco Aplicaciones', valueCredential: '2' },
  { textCredential: 'Credibanco Tramas', valueCredential: '4' },
  { textCredential: 'Redeban Aplicaciones (En desarrollo)', valueCredential: '6', disabled: true },
  { textCredential: 'Redeban Servicios (En desarrollo)', valueCredential: '7', disabled: true },
  { textCredential: 'Wompi (No disponible)', valueCredential: 'WOMPI', disabled: true },
]
